import React from "react"
import {
  HandleValidDate,
  FormatDate,
  FormatDateDDMMMYYYY,
} from "helpers/method_helper"

const HouseholdMonitoringColumns = [
  {
    Header: "Month",
    accessor: "TrainingMonth",
  },
  {
    Header: "Postcode Area",
    accessor: "Postcode",
  },
  {
    Header: "Households with Children",
    accessor: "ChildrenCount",
  },
  {
    Header: "Households with Pensioners",
    accessor: "PensionerCount",
  },
  {
    Header: "Households with Disabled Person",
    accessor: "DisabledCount",
  },
  {
    Header: "Other Households",
    accessor: "OtherCount",
  },
  {
    Header: "Training Date",
    accessor: row =>
      row.TrainingDate ? FormatDateDDMMMYYYY(row.TrainingDate) : "",
  },
  {
    Header: "Venue Name",
    accessor: "Venue",
  },
  {
    Header: "Training Type",
    accessor: "TrainingType",
  },
  {
    Header: "Training Subjects",
    accessor: "Subjects",
    Cell: ({ value }) => (
      <div>
        {value.split(",").map((label, index) => (
          <div key={index}>{label.trim()}</div>
        ))}
      </div>
    ),
  },
  {
    Header: "Delivery Postcode",
    accessor: "Delivery",
  },
]

export { HouseholdMonitoringColumns }
